import { useEffect } from 'react';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';

import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import PrivacyCommitments from '@/components/modules/Privacy/PrivacyCommitments';
import PrivacyComparison from '@/components/modules/Privacy/PrivacyComparison';
import PrivacyHero from '@/components/modules/Privacy/PrivacyHero';
import PrivateByDesign from '@/components/modules/Privacy/PrivateByDesign';
import TheProblem from '@/components/modules/Privacy/TheProblem';
import TheRecord from '@/components/modules/Privacy/TheRecord';
import WhoItsFor from '@/components/modules/Privacy/WhoItsFor';
import WebinarAnnouncement from '@/components/modules/Webinar/WebinarAnnouncement';

const Privacy = () => {
  // Force light mode for marketing pages
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  return (
    <div className="bg-white">
      <NextSeo
        title="Private AI, Built for Business"
        description="Use Chat.co with AWS Bedrock for zero-retention inference by default, no model training on inputs or outputs, and governed AI agents for public and private knowledge."
        canonical="https://chat.co/privacy"
        openGraph={{
          type: 'website',
          url: 'https://chat.co/privacy',
          title: 'Private AI, built for business | Chat.co',
          description:
            'Chat.co combines AWS Bedrock zero-retention inference with governed access, encrypted data, and grounded answers with citations.',
          images: [
            {
              url: 'https://chat.co/images/og-privacy.png',
              width: 1200,
              height: 630,
              alt: 'Chat.co private AI for business',
            },
          ],
        }}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: 'Home', item: 'https://chat.co' },
          { position: 2, name: 'Privacy', item: 'https://chat.co/privacy' },
        ]}
      />
      <Header />
      <WebinarAnnouncement />
      <PrivacyHero />
      <TheProblem />
      <TheRecord />
      <PrivateByDesign />
      <WhoItsFor />
      <PrivacyComparison />
      <PrivacyCommitments />
      <Footer />
    </div>
  );
};

export default Privacy;
